module.exports = __webpack_public_path__ + "assets/scoober-logo-desktop-en-220f73.svg";